import { defineStore } from "pinia";

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    isLogin: false,
  }),
  actions: {
    setLogin(status) {
      this.isLogin = status;
    },
  },
});
